<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="text-h5 pa-4">
        {{ $t("admin.recalculate-historical-title") }}
      </v-card-title>
      <v-card-text class="pb-0">
        <v-container>
          <v-row>
            <v-col cols="12">
              <p class="mb-4">
                {{
                  $t("admin.recalculate-historical-description", {
                    contractName: contractInfo?.name || "",
                  })
                }}
              </p>
              <v-text-field
                v-model="targetDate"
                type="datetime-local"
                :label="$t('admin.target-date')"
                variant="outlined"
                density="comfortable"
                :max="maxDate"
                :rules="[rules.required, rules.notFuture]"
                :hint="$t('admin.target-date-hint')"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey-darken-1" variant="text" @click="closeDialog">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="#ffb300"
          variant="elevated"
          @click="confirmRecalculate"
          :disabled="!isValidDate"
          :loading="loading"
        >
          {{ $t("admin.recalculate") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RecalculateHistoricalDialog",
  props: {
    modelDialog: {
      type: Boolean,
      required: true,
    },
    contractInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      targetDate: "",
      loading: false,
      rules: {
        required: (value) => !!value || this.$t("admin.date-required"),
        notFuture: (value) => {
          if (!value) return true;
          const selectedDate = new Date(value);
          const now = new Date();
          return selectedDate <= now || this.$t("admin.date-cannot-be-future");
        },
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    /**
     * Date maximale autorisée (date actuelle)
     */
    maxDate() {
      const now = new Date();
      return now.toISOString().slice(0, 16);
    },
    /**
     * Vérifie si la date saisie est valide
     */
    isValidDate() {
      if (!this.targetDate) return false;
      const selectedDate = new Date(this.targetDate);
      const now = new Date();
      return selectedDate <= now;
    },
  },
  methods: {
    /**
     * Ferme la dialog et réinitialise les données
     */
    closeDialog() {
      this.targetDate = "";
      this.loading = false;
      this.$emit("close");
    },
    /**
     * Confirme le recalcul et envoie les données au parent
     */
    confirmRecalculate() {
      if (!this.isValidDate) {
        this.$store.dispatch("showSnackbar", {
          message: this.$t("admin.invalid-date"),
          color: "warning",
        });
        return;
      }

      // Convertir la date locale en ISO string pour l'API
      const isoDate = new Date(this.targetDate).toISOString();

      this.$emit("confirm", {
        contractId: this.contractInfo.id,
        targetDate: isoDate,
      });
    },
  },
  watch: {
    /**
     * Préremplit la date avec la date de fin du contrat si disponible
     */
    modelDialog(newVal) {
      if (newVal && this.contractInfo?.endDate) {
        const endDate = new Date(this.contractInfo.endDate);
        // Format datetime-local : YYYY-MM-DDTHH:mm
        this.targetDate = endDate.toISOString().slice(0, 16);
      }
    },
  },
};
</script>
